/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const Box = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 48px;
`;

export const Container = styled.div`
  background: #fff;
  padding: 32px 40px;
  border-radius: 8px;
  grid-column: span 2;
  box-shadow: 0px 1px 3px rgba(30, 50, 70, 0.1), 0px 1px 2px rgba(30, 50, 70, 0.06);
`;
